import React, { useState } from 'react'
import { Input } from '@intelie/ui'
import styled, { useTheme } from 'styled-components'
import moment, { Moment } from 'moment'

type Prop = {
    id?: string
    title: string
    date?: Moment
    name?: string
    disabled?: boolean
    className?: string
    required?: boolean
    format?: string
    time?: boolean
    validationState?: 'default' | 'error' | 'valid' | 'warning'
    onChange(date: Moment): void
}

const CustomDatePicker = ({
    id,
    title,
    date,
    name,
    disabled,
    className,
    format = 'MM/DD/yyyy h:mm A',
    required = false,
    time = false,
    validationState,
    onChange
}: Prop): JSX.Element => {
    const theme = useTheme().themeName

    const [selectedDate, setSelectedDate] = useState<Moment>(date)

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const timestamp = time
            ? moment(event.target.value, 'YYYY-MM-DDTHH:mm')
            : moment(event.target.value, 'YYYY-MM-DD')

        setSelectedDate(timestamp)
        onChange(timestamp)
    }

    return (
        <>
            <StyledInput
                type={time ? 'datetime-local' : 'date'}
                id={id}
                name={name}
                label={title}
                theme={theme}
                disabled={disabled}
                required={required}
                placeholder={format}
                className={className}
                value={selectedDate?.format(time ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD')}
                onChange={handleChange}
                inputState={validationState}
            />
        </>
    )
}

export default CustomDatePicker

const StyledInput = styled(Input)<{ theme: string }>`
    gap: 2px;

    label {
        padding: 0;
    }

    input {
        color-scheme: ${({ theme }) => theme};
        letter-spacing: -1px;
    }
`
